import myHeader from "../../components/header.vue"
import myFooter from "../../components/footer.vue"
import examDialog from '../../components/examDialog/examDialog.vue'
import {
  getUserCourseStudyDetail,
  getUserCourseStudyDetailFromSingleCourse,
  courseExerciseList,
  getStudyreCommendList,
  getTheNextStudyCourse,
  getEmployeeInformation,
  getEntpCourseConfigCurrent,
  getEmployeeExerciseCountByExerciseId,
  getEmployeeCourseOverStatus,
  getActive,
  exerciseDetailVerification,
  getEntpExerciseConfigCurrent,
  getStudyccCountToday
} from '../../apiCloud/courseDetail'
import {
saveUserStudyTime,
getVideoIds
} from "../../apiCloud/coursePlay";
import {
  getEntpOtherConfig
} from "../../apiCloud/common";
import {
  getToken
} from "@/utilsCloud/auth";
let that

require('video.js/dist/video-js.css') //视频
require('vue-video-player/src/custom-theme.css')

let echarts = require('echarts/lib/echarts')
require('echarts/lib/chart/pie')
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
export default {
  components: {
    myHeader,
    myFooter,
    examDialog
  },
  data() {
    return {
      activeName: "second",
      inCount: 0,
      // courseBaseInfo:[],
      cateName: '', //课程名称
      courseContent: '', //课程内容
      coursePic: '', //课程封面图
      courseTeacher: '', //讲师
      courseTotalHours: '', //课程总课时
      courseName: '',
      courseCateTotal: 0, //总节数
      courseCateCount: 0, // 已学章节
      courseCate: 0,
      courseEndLine: '', //截止数据
      nextStudyCourse: '', //下一个学习任务
      buyStatus: '', //下一个学习任务
      courseDistributionMode: "", //是否为激活课程
      nextCcId: '',
      entpName: sessionStorage.getItem("empName"), // 企业名称
      nextResouceId: '',
      nextVId: '',
      nextCourseDelayTime: 0,
      resouceHours: '', //单节课程的学习时长
      baseInfoCatalogList: [],
      studyreCommendList: [],
      exerciseList: [],
      playTime: 0,
      currentTime: 0,
      allTime: 0,
      percentage: '0%',
      isLogin: true,
      orderPackagebagId: '',
      isJx: false,
      isHomeOrPublic: false,
      isCourseDetail: false,
      regId: "",
      courseType: "",
      popupDialog: false,
      formData: {},
      rules: {
        activationCode: [{
          required: true,
          message: "请输入激活码",
          trigger: "blur"
        }],
      },
      trialFlag: '',
      popBuy: false,
      salesmanCode: "",
      enterpriseId: '',
      practicePopupDialog:false, //练习弹窗
      goExerciseId:'',
      ccName:'',
      ccId:'',
      isPdf:false, //
      studyEntpId:'',

      needPracticePhoto:0 // TODO 练习是否需要拍照
    }
  },
  computed: {},
  watch: {
    '$route'(to, from) {
      this.$router.go(0);
    },
  },
  created() {
    that = this
    this.studyEntpId = that.$route.query.studyEntpId || ''
    /*  window.addEventListener('popstate', function(){
          that.goBack()
      })*/
    that.goInter();


  },
  mounted() {
    var publicCourse = document.getElementById("detail")
    publicCourse.style.minHeight = document.body.scrollHeight - 90 - 257 + "px"
    that.getLessonConfiguration();
    this.getConfig();
    if (localStorage.getItem('enterpriseId')) {
      this.enterpriseId = localStorage.getItem('enterpriseId')
    }
  },
  beforeDestroy() {
    /*   window.removeEventListener('popstate', that.goBack, false);*/
  },
  beforeRouteLeave(to, from, next) {
    if (to.name == 'coursePlay' || to.name == 'coursePlayNew') {
      next()
    } else {
      localStorage.removeItem('studyPackagebagId');
      localStorage.removeItem('studyRegId');
      next()
    }
  },
  methods: {
    // 获取配置信息
    getConfig() {
      let data = {
        systemId: 0, // 系统ID
        courseId: this.courseId, // 课程ID
        packagebagId: this.packagebagId // 包编号
      };
      getEntpCourseConfigCurrent(data).then(res => {
        if (res.code == 200) {
          this.trialFlag = res.data.trialFlag
          // TODO 练习是否需要拍照
          this.needPracticePhoto = res.data.needPracticePhoto
        }
      })
    },
    // 激活课程
    determineActivation(formName) {
      let data = {
        activationCode: this.formData.activationCode
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          getActive(data).then(res => {
            if (res.code == 200) {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.popupDialog = false;
            } else {
              this.$message.error(res.msg);
            }
          })
        }
      })

    },
    goInter() {
      this.courseId = localStorage.getItem("courseId")
      this.tokenId = getToken();
      if (this.tokenId == undefined || this.tokenId == "") {
        setTimeout(() => {
          this.getCourseBaseInfo()
          this.getStudyreCommendList()
          this.getCourseExerciseList()
          this.isLogin = false
        }, 200)
      } else {
        this.getCourseBaseInfo()
        this.getCourseExerciseList()
        this.getStudyreCommendList()
        this.getTheNextStudyCourse()
        this.$nextTick(()=>{
          this.drawLine();
        })
      }
      if (localStorage.getItem("isJx") == "true") { // 是否是江西代理商访问
        this.isJx = true;
      }
    },
    //课程详情
    getCourseBaseInfo() {
      that.courseType = localStorage.getItem("courseType");
      this.regId = localStorage.getItem("studyRegId");
      let getUrl, data;
      if (that.courseType == '专业课程' || that.courseType == '') {
        getUrl = getUserCourseStudyDetail
        data = {
          courseId: this.courseId,
          regId: this.regId,
          studyEntpId:that.studyEntpId
        }
        that.courseCate = 1
      } else {
        getUrl = getUserCourseStudyDetailFromSingleCourse
        data = {
          courseId: this.courseId,
          studyEntpId:that.studyEntpId
        }
        that.courseCate = 0
      }
      getUrl(data).then(res => {
        if (res.code == 200) {
          if (res.data.salesmanCode) {
            this.salesmanCode = res.data.salesmanCode || '' // 机构二维码
          }
          this.cateName = res.data.cateName
          this.courseContent = res.data.courseContent
          this.coursePic = res.data.coursePic
          this.courseTeacher = res.data.courseTeacher
          this.courseTotalHours = res.data.courseTotalHours
          this.courseName = res.data.courseName
          this.courseId = res.data.courseId
          this.regId = res.data.regId
          this.coursePic = res.data.coursePic
          this.courseCateTotal = res.data.courseCateTotal
          this.courseCateCount = res.data.courseCateCount
          this.resouceHours = res.data.resouceHours
          this.baseInfoCatalogList = res.data.courseCatalogList
          for( var i in this.baseInfoCatalogList){
            for(var j in this.baseInfoCatalogList[i].cousecate){
              var urlRequest = this.baseInfoCatalogList[i].cousecate[j].coursewareUrl
              if(urlRequest != null){
                const extension = urlRequest.substring(urlRequest.lastIndexOf('.') +1).toLowerCase()
                if(extension =='pdf'){
                this.baseInfoCatalogList[i].cousecate[j].isPdf = true;
                }else{
                  this.baseInfoCatalogList[i].cousecate[j].isPdf = false;
                }
              }
            }
          }
          this.buyStatus = res.data.buyStatus
          this.courseEndLine = res.data.courseEndLine ? res.data.courseEndLine : 0
          this.percentage = res.data.courseCateTotal / res.data.courseCateCount
          this.percentage = this.GetPercent(this.courseCateCount, this.courseCateTotal);
          this.$nextTick(()=>{
            this.drawLine();
          })
          if (localStorage.getItem("studyPackagebagId") && localStorage.getItem("studyPackagebagId") != "") {
            this.packagebagId = localStorage.getItem("studyPackagebagId")
            this.regId = localStorage.getItem("studyRegId")
          } else {
            this.regId = res.data.regId;
            this.packagebagId = res.data.packagebagId
          }
        } else {
          this.$message.error(res.msg)
        }

      })

    },
    //我的练习列表
    getCourseExerciseList() {
      let data = {
        courseId: this.courseId,
      }
      courseExerciseList(data).then(res => {
        if (res.code == 200) {
          this.exerciseList = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    //为你推荐
    getStudyreCommendList() {
      return;
      let data = {
        courseId: this.courseId,
        // orderPackagebagId: this.packagebagId
      }
      getStudyreCommendList(data).then(res => {
        if (res.code == 200) {
          this.studyreCommendList = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    //下一个学习任务
    getTheNextStudyCourse() {
      let data = {
        // packagebagId: this.orderPackagebagId ? this.orderPackagebagId : '',
        courseId: this.courseId
      }
      getTheNextStudyCourse(data).then(res => {
        // console.log("下一个学习任务", res)
        if (res.code == 200) {
          if (res.data == 0) {
            this.nextStudyCourse = "本课已学完"
          } else {
            this.nextStudyCourse = res.data.ccName
            this.nextCcId = res.data.ccId
            this.nextResouceId = res.data.resouceId
            this.nextVId = res.data.vid
            this.nextCourseDelayTime = res.data.courseDelayTime
          }
        } else {
          this.$message.error(res.msg)
        }

      })
    },
    //为你推荐点击进详情
    GotoCourseDetail(id, packagebagId) {
      /*     that.$router.push({
               path: "/courseDetail",
               params: {
                   courseId: id,
                   packagebagId: packagebagId ? packagebagId : '',
                   oldPage:1,
               }
           })*/
      localStorage.setItem("packagebagId", packagebagId)
      localStorage.setItem("courseId", id)
      localStorage.setItem("isCourseDetail", true)
      that.goInter();
    },
    // 看课权限认证
    getAuthor() {
      var params = {
        courseId: this.courseId,
        packagebagId: this.packagebagId
      }
      getUserCourseStudyConfig(params).then(res => {
        if (res.code == 200) {

        }
      })
    },

    //获取当前培训机构其他配置信息
    getLessonConfiguration() {
      let data = {}
      getEntpOtherConfig(data).then((res) => {
        if (res.data.visitorMode == 1) {
          if (!getToken()) {
            router.push({
              path: "/login"
            })
          } else {}
        } else {
          this.courseDistributionMode = res.data.courseDistributionMode
        }
      });
    },
    // 判断所有情况之前先进行是否购买的区别      0 课程分发 1激活码 2在线支付
    beforePlayVideo() {
      if(this.trialFlag == 1  && (this.tokenId == undefined || this.tokenId == "")){
        this.$router.replace({
          name: "coursePlayNew",
          params: {
            courseId: this.courseId,
            packagebagId: this.packagebagId,
            trialFlag: this.trialFlag
          }
        });
        let playData = {
          courseId: this.courseId,
          regId: this.regId,
          packagebagId: this.packagebagId,
          ccId:this.ccId,
          vid:this.vid,
          courseDelayTime:this.courseDelayTime,
          courseOver:this.courseOver,
          liSelected: 0 + "-" + 0,
          resouceHours:this.resouceHours,
          trialFlag:this.trialFlag
        };
        localStorage.setItem("playData", JSON.stringify(playData))
      }else{
      if (this.buyStatus == null) {
        this.playVideo()
      } else if (this.buyStatus == 0) {
        if (this.trialFlag == 1) {
          this.$router.replace({
            name: "coursePlayNew",
            params: {
              courseId: this.courseId,
              packagebagId: this.packagebagId,
              regId: this.regId,
              trialFlag: this.trialFlag
            }
          });
          let playData = {
            courseId: this.courseId,
            regId: this.regId,
            packagebagId: this.packagebagId,
            trialFlag: this.trialFlag
          };
          localStorage.setItem("playData", JSON.stringify(playData))
        } else {
          if (this.courseDistributionMode == 0) {
            if (this.salesmanCode) {
              this.popBuy = true;
            } else {
              this.$alert("该资源为付费内容，请先联系" + this.entpName + "购买，方可使用！", '提示', {
                confirmButtonText: '确定',
                callback: action => {}
              });
            }
          } else {
            this.popupDialog = true
          }
        }
      } else {
        this.playVideo()
      }
    }
    },
    //开始学习--播放视频
    playVideo() {
      getEmployeeInformation().then(res => { //获取个人信息 (根据能否获取到个人信息判断是否登录)
        if (res.code == 200) {
          //检测是否需要实名认证
          let data = {
            systemId: 0, // 系统ID
            courseId: this.courseId, // 课程ID
            packagebagId: this.packagebagId // 包编号
          };
          getEntpCourseConfigCurrent(data).then(response => {
            if (response.data.needRealName == 0) {
              if (!res.data.empIdcardFront) {
                this.$message({
                  message: '请先进行实名认证',
                  type: 'warning',
                  duration: '3000',
                })
              } else {
                this.toPlayVideo()
              }
            } else {
              this.toPlayVideo()
            }
          })
        } else {
          this.$message.error(res.msg)
        }
      })
    },

    //点击章节--播放视频
    playOneVideo(vid, ccId, courseDelayTime, index, sub, courseOver, resouceHours, trialFlag , practicePlayFlag,exerciseId,ccName) {
        if (this.trialFlag == 1 && trialFlag == 1 && (this.tokenId == undefined || this.tokenId == "")) {
          this.$router.replace({
            name: "coursePlayNew",
            params: {
              courseId: this.courseId,
              packagebagId: this.packagebagId,
              ccId: ccId,
              vid: vid,
              courseDelayTime: courseDelayTime,
              courseOver: courseOver,
              liSelected: index + "-" + sub,
              resouceHours: resouceHours,
              trialFlag: trialFlag,
              practicePlayFlag : practicePlayFlag,
              exerciseId : exerciseId,
              ccName : ccName,
              isPdf:false,
            }
          });
          let playData = {
            courseId: this.courseId,
            regId: this.regId,
            packagebagId: this.packagebagId,
            ccId,
            vid,
            courseDelayTime,
            courseOver,
            liSelected: index + "-" + sub,
            resouceHours,
            trialFlag,
            practicePlayFlag,
            exerciseId,
            ccName,
            isPdf:false
          };
          localStorage.setItem("playData", JSON.stringify(playData))
        } else {
          const getVideoIdsParams = { 
            ccId,
            regId:this.regId
          }
          getVideoIds(getVideoIdsParams).then(getVideoIdsRes=>{
            getEmployeeInformation().then(res => { //获取个人信息 (根据能否获取到个人信息判断是否登录)
              if (res.code == 200) {
                let empHeadportrait = res.data.empHeadportrait ? res.data.empHeadportrait : "../../../static/empHeadportrait.png"
                localStorage.setItem("empHeadportrait", empHeadportrait);
                if (this.buyStatus == 0) {
                  if (trialFlag == 1 && this.trialFlag == 1) {
                    this.$router.replace({
                      name: "coursePlayNew",
                      params: {
                        courseId: this.courseId,
                        packagebagId: this.packagebagId,
                        ccId: ccId,
                        vid: vid,
                        courseDelayTime: courseDelayTime,
                        courseOver: courseOver,
                        liSelected: index + "-" + sub,
                        resouceHours: resouceHours,
                        trialFlag: trialFlag,
                        practicePlayFlag : practicePlayFlag,
                        exerciseId : exerciseId,
                        ccName : ccName,
                        isPdf:false
                      }
                    });
                    let playData = {
                      courseId: this.courseId,
                      regId: this.regId,
                      packagebagId: this.packagebagId,
                      ccId,
                      vid,
                      courseDelayTime,
                      courseOver,
                      liSelected: index + "-" + sub,
                      resouceHours,
                      trialFlag,
                      practicePlayFlag,
                      exerciseId,
                      ccName,
                      isPdf:false
                    };
                    localStorage.setItem("playData", JSON.stringify(playData))
                  } else {
                    if (this.salesmanCode) {
                      this.popBuy = true;
                    } else {
                      this.$alert("该资源为付费内容，请先联系" + this.entpName + "购买，方可使用！", '提示', {
                        confirmButtonText: '确定',
                        callback: action => {}
                      });
                    }
                  }
                } else {
                  if (this.courseEndLine > 0 || this.courseType == "私有课程") {
                    if (vid) { //判断这一节课是否上传视频
                      if (this.courseType == "私有课程") {
                        this.$router.replace({
                          // path: "/coursePlay",
                          name: "coursePlayByPrivate",
                          params: {
                            courseId: this.courseId,
                            packagebagId: this.packagebagId,
                            ccId: ccId,
                            vid: vid,
                            courseDelayTime: courseDelayTime,
                            courseOver: courseOver,
                            liSelected: index + "-" + sub,
                            resouceHours: resouceHours
                          }
                        });
                      } else {
                        //检测是否需要实名认证、页面多开
                        let datafig = {
                          systemId: 0, // 系统ID
                          courseId: this.courseId, // 课程ID
                          packagebagId: this.packagebagId // 包编号
                        };
                        getEntpCourseConfigCurrent(datafig).then(response => {
                          if (response.data.needRealName == 0) {
                            if (!res.data.empIdcardFront) {
                              this.$message({
                                message: '请先进行实名认证',
                                type: 'warning',
                                duration: '3000',
                              })
                            } else {
                              if (response.data.needLimit == 0) {
                                let data = {}
                                data.courseId = this.courseId
                                getStudyccCountToday(data).then(ressssss => {
                                  if (ressssss.data >= response.data.limitClassHour) {
                                    if (courseOver == 1 || courseOver == 0) {
                                      this.$router.replace({
                                        name: "coursePlay",
                                        params: {
                                          courseId: this.courseId,
                                          packagebagId: this.packagebagId,
                                          ccId: ccId,
                                          vid: vid,
                                          courseDelayTime: courseDelayTime,
                                          courseOver: courseOver,
                                          liSelected: index + "-" + sub,
                                          resouceHours: resouceHours,
                                        },
                                        query:{
                                          studyEntpId:that.studyEntpId
                                        }
                                      });
                                    } else {
                                      this.$message({
                                        message: '当日可学习课时已学完，请明日在进行学习',
                                        type: 'warning',
                                        duration: '3000',
                                      })
                                    }
                                  } else {
                                    this.$router.replace({
                                      name: "coursePlay",
                                      params: {
                                        courseId: this.courseId,
                                        packagebagId: this.packagebagId,
                                        ccId: ccId,
                                        vid: vid,
                                        courseDelayTime: courseDelayTime,
                                        courseOver: courseOver,
                                        liSelected: index + "-" + sub,
                                        resouceHours: resouceHours
                                      },
                                      query:{
                                        studyEntpId:that.studyEntpId
                                      }
                                    });
                                  }
                                })
                              } else {
                                this.$router.replace({
                                  name: "coursePlay",
                                  params: {
                                    courseId: this.courseId,
                                    packagebagId: this.packagebagId,
                                    ccId: ccId,
                                    vid: vid,
                                    courseDelayTime: courseDelayTime,
                                    courseOver: courseOver,
                                    liSelected: index + "-" + sub,
                                    resouceHours: resouceHours
                                  },
                                  query:{
                                    studyEntpId:that.studyEntpId
                                  }
                                });
                              }
                            }
                          } else {
                            if (response.data.needLimit == 0) {
                              let data = {}
                              data.courseId = this.courseId
                              getStudyccCountToday(data).then(ressssss => {
                                if (ressssss.data >= response.data.limitClassHour) {
                                  if (courseOver == 1 || courseOver == 0) {
                                    this.$router.replace({
                                      name: "coursePlay",
                                      params: {
                                        courseId: this.courseId,
                                        packagebagId: this.packagebagId,
                                        ccId: ccId,
                                        vid: vid,
                                        courseDelayTime: courseDelayTime,
                                        courseOver: courseOver,
                                        liSelected: index + "-" + sub,
                                        resouceHours: resouceHours
                                      },
                                      query:{
                                        studyEntpId:that.studyEntpId
                                      }
                                    });
                                  } else {
                                    this.$message({
                                      message: '当日可学习课时已学完，请明日在进行学习',
                                      type: 'warning',
                                      duration: '3000',
                                    })
                                  }
                                } else {
                                  this.$router.replace({
                                    name: "coursePlay",
                                    params: {
                                      courseId: this.courseId,
                                      packagebagId: this.packagebagId,
                                      ccId: ccId,
                                      vid: vid,
                                      courseDelayTime: courseDelayTime,
                                      courseOver: courseOver,
                                      liSelected: index + "-" + sub,
                                      resouceHours: resouceHours
                                    },
                                    query:{
                                      studyEntpId:that.studyEntpId
                                    }
                                  });
                                }
                              })
                            } else {
                              this.$router.replace({
                                name: "coursePlay",
                                params: {
                                  courseId: this.courseId,
                                  packagebagId: this.packagebagId,
                                  ccId: ccId,
                                  vid: vid,
                                  courseDelayTime: courseDelayTime,
                                  courseOver: courseOver,
                                  liSelected: index + "-" + sub,
                                  resouceHours: resouceHours,
                                  practicePlayFlag : practicePlayFlag,
                                  exerciseId : exerciseId,
                                  ccName : ccName
                                },
                                query:{
                                  studyEntpId:that.studyEntpId
                                }
                              });
                            }
                          }
                        })
                      }
                      localStorage.setItem("oldTokenId", localStorage.getItem("tokenId"));
                      let playData = {
                        courseId: this.courseId,
                        regId: this.regId,
                        packagebagId: this.packagebagId,
                        ccId,
                        vid,
                        courseDelayTime,
                        courseOver,
                        liSelected: index + "-" + sub,
                        resouceHours,
                        practicePlayFlag,
                        exerciseId,
                        ccName,
                        isPdf:this.isPdf
                      };
                      localStorage.setItem("playData", JSON.stringify(playData))
                    } else {
                      this.$message({
                        message: '还没有上传视频哦！',
                        type: 'warning',
                        duration: '3000',
                      })
                    }
                  } else {
                    this.$message({
                      message: '课程已经过了有效期，请联系' + this.entpName + '续费',
                      type: 'warning',
                      duration: '3000',
                    })
                  }
                }
              } else {
                this.$message.error(res.msg)
              }
            })
          })
        }
    },
    // 普通课件下载
    linkOpenPage(vid, ccId, courseDelayTime, index, sub, courseOver, resouceHours ,trialFlag,practicePlayFlag,exerciseId,coursewareUrl,ccName) {      
      if (this.trialFlag == 1 && trialFlag == 1 && (this.tokenId == undefined || this.tokenId == "")) {
        const extension = coursewareUrl.substring(coursewareUrl.lastIndexOf('.') + 1).toLowerCase();
        if(extension =='pdf'){
        this.$router.replace({
          name: "coursePlayNew",
          params: {
            courseId: this.courseId,
            packagebagId: this.packagebagId,
            ccId: ccId,
            vid: vid,
            courseDelayTime: courseDelayTime,
            courseOver: courseOver,
            liSelected: index + "-" + sub,
            resouceHours: resouceHours,
            trialFlag: trialFlag,
            practicePlayFlag : practicePlayFlag,
            exerciseId : exerciseId,
            ccName : ccName,
            isPdf:true,
            coursewareUrl:coursewareUrl
          }
        });
        }else if(extension =='txt'){
          let strData = new Blob([coursewareUrl], { type: 'text/plain;charset=utf-8' });
          saveAs(strData,ccName);
          let data = {
            packagebagId: this.packagebagId, // 套餐包Id
            regId: this.regId,
            courseId: this.courseId, // 课程Id
            ccId: ccId, //视频VID
            courseDelayTime: 1, //视频播放时长
            courseOver: 1,
          };
          saveUserStudyTime(data).then(res => {
            if (res.code ==200) {
              this.getCourseBaseInfo()
            }
          })
        }else{
          window.open(coursewareUrl)
          let data = {
            packagebagId: this.packagebagId, // 套餐包Id
            regId: this.regId,
            courseId: this.courseId, // 课程Id
            ccId: ccId, //视频VID
            courseDelayTime: 1, //视频播放时长
            courseOver: 1,
          };
          saveUserStudyTime(data).then(res => {
            if (res.code ==200) {
              this.getCourseBaseInfo()
            }
          })
        }
        let playData = {
          courseId: this.courseId,
          regId: this.regId,
          packagebagId: this.packagebagId,
          ccId,
          vid,
          courseDelayTime,
          courseOver,
          liSelected: index + "-" + sub,
          resouceHours,
          trialFlag,
          practicePlayFlag,
          exerciseId,
          ccName,
          isPdf:true,
          coursewareUrl:coursewareUrl
        };
        localStorage.setItem("playData", JSON.stringify(playData))
      } else {
        getEmployeeInformation().then(res => { //获取个人信息 (根据能否获取到个人信息判断是否登录)
          if (res.code == 200) {
            let empHeadportrait = res.data.empHeadportrait ? res.data.empHeadportrait : "../../../static/empHeadportrait.png"
            localStorage.setItem("empHeadportrait", empHeadportrait);
            if (this.buyStatus == 0) {
              if (trialFlag == 1 && this.trialFlag == 1) {
                const extension = coursewareUrl.substring(coursewareUrl.lastIndexOf('.') + 1).toLowerCase();
                if(extension =='pdf'){
                this.$router.replace({
                  name: "coursePlayNew",
                  params: {
                    courseId: this.courseId,
                    packagebagId: this.packagebagId,
                    ccId: ccId,
                    vid: vid,
                    courseDelayTime: courseDelayTime,
                    courseOver: courseOver,
                    liSelected: index + "-" + sub,
                    resouceHours: resouceHours,
                    trialFlag: trialFlag,
                    practicePlayFlag : practicePlayFlag,
                    exerciseId : exerciseId,
                    ccName : ccName,
                    isPdf:true,
                    coursewareUrl:this.isPdf==true?coursewareUrl:''
                  }
                });
              }else if(extension =='txt'){
                let strData = new Blob([coursewareUrl], { type: 'text/plain;charset=utf-8' });
                saveAs(strData,ccName);
                let data = {
                  packagebagId: this.packagebagId, // 套餐包Id
                  regId: this.regId,
                  courseId: this.courseId, // 课程Id
                  ccId: ccId, //视频VID
                  courseDelayTime: 1, //视频播放时长
                  courseOver: 1,
                };
                saveUserStudyTime(data).then(res => {
                  if (res.code ==200) {
                    this.getCourseBaseInfo()
                  }
                })
              }else{
                window.open(coursewareUrl)
                let data = {
                  packagebagId: this.packagebagId, // 套餐包Id
                  regId: this.regId,
                  courseId: this.courseId, // 课程Id
                  ccId: ccId, //视频VID
                  courseDelayTime: 1, //视频播放时长
                  courseOver: 1,
                };
                saveUserStudyTime(data).then(res => {
                  if (res.code ==200) {
                    this.getCourseBaseInfo()
                  }
                })
              }
                const extension1 = coursewareUrl.substring(coursewareUrl.lastIndexOf('.') + 1).toLowerCase();
                if(extension1=='pdf'){
                  this.isPdf = true
                }else{
                  this.isPdf =false;
                }
                let playData = {
                  courseId: this.courseId,
                  regId: this.regId,
                  packagebagId: this.packagebagId,
                  ccId,
                  vid,
                  courseDelayTime,
                  courseOver,
                  liSelected: index + "-" + sub,
                  resouceHours,
                  trialFlag,
                  practicePlayFlag,
                  exerciseId,
                  ccName,
                  isPdf:this.isPdf,
                  coursewareUrl:this.isPdf==true?coursewareUrl:''
                };
                localStorage.setItem("playData", JSON.stringify(playData))
              } else {
                if (this.salesmanCode) {
                  this.popBuy = true;
                } else {
                  this.$alert("该资源为付费内容，请先联系" + this.entpName + "购买，方可使用！", '提示', {
                    confirmButtonText: '确定',
                    callback: action => {}
                  });
                }
              }
            } else {
              if (this.courseEndLine > 0 || this.courseType == "私有课程") {
                if (vid) { //判断这一节课是否上传视频
                  if (this.courseType == "私有课程") {
                    this.$router.replace({
                      // path: "/coursePlay",
                      name: "coursePlayByPrivate",
                      params: {
                        courseId: this.courseId,
                        packagebagId: this.packagebagId,
                        ccId: ccId,
                        vid: vid,
                        courseDelayTime: courseDelayTime,
                        courseOver: courseOver,
                        liSelected: index + "-" + sub,
                        resouceHours: resouceHours
                      }
                    });
                  } else {
                    //检测是否需要实名认证、页面多开
                    let datafig = {
                      systemId: 0, // 系统ID
                      courseId: this.courseId, // 课程ID
                      packagebagId: this.packagebagId // 包编号
                    };
                    getEntpCourseConfigCurrent(datafig).then(response => {
                      if (response.data.needRealName == 0) {
                        if (!res.data.empIdcardFront) {
                          this.$message({
                            message: '请先进行实名认证',
                            type: 'warning',
                            duration: '3000',
                          })
                        } else {
                          if (response.data.needLimit == 0) {
                            let data = {}
                            data.courseId = this.courseId
                            getStudyccCountToday(data).then(ressssss => {
                              if (ressssss.data >= response.data.limitClassHour) {
                                if (courseOver == 1 || courseOver == 0) {
                                  const extension = coursewareUrl.substring(coursewareUrl.lastIndexOf('.') + 1).toLowerCase();
                                  if(extension =='pdf'){
                                    this.$router.replace({
                                      name: "coursePlay",
                                      params: {
                                        courseId: this.courseId,
                                        packagebagId: this.packagebagId,
                                        ccId: ccId,
                                        vid: vid,
                                        courseDelayTime: courseDelayTime,
                                        courseOver: courseOver,
                                        liSelected: index + "-" + sub,
                                        resouceHours: resouceHours,
                                        isPdf:true
                                      },
                                      query:{
                                        studyEntpId:that.studyEntpId
                                      }
                                    });
                                  }else if(extension =='txt'){
                                    let strData = new Blob([coursewareUrl], { type: 'text/plain;charset=utf-8' });
                                    saveAs(strData,ccName);
                                    let data = {
                                      packagebagId: this.packagebagId, // 套餐包Id
                                      regId: this.regId,
                                      courseId: this.courseId, // 课程Id
                                      ccId: ccId, //视频VID
                                      courseDelayTime: 1, //视频播放时长
                                      courseOver: 1,
                                    };
                                    saveUserStudyTime(data).then(res => {
                                      if (res.code ==200) {
                                        this.getCourseBaseInfo()
                                      }
                                    })
                                  }else{
                                    window.open(coursewareUrl)
                                    let data = {
                                      packagebagId: this.packagebagId, // 套餐包Id
                                      regId: this.regId,
                                      courseId: this.courseId, // 课程Id
                                      ccId: ccId, //视频VID
                                      courseDelayTime: 1, //视频播放时长
                                      courseOver: 1,
                                    };
                                    saveUserStudyTime(data).then(res => {
                                      if (res.code ==200) {
                                        this.getCourseBaseInfo()
                                      }
                                    })
                                  }
                                } else {
                                  this.$message({
                                    message: '当日可学习课时已学完，请明日在进行学习',
                                    type: 'warning',
                                    duration: '3000',
                                  })
                                }
                              } else {
                                const extension = coursewareUrl.substring(coursewareUrl.lastIndexOf('.') + 1).toLowerCase();
                                if(extension =='pdf'){
                                  this.$router.replace({
                                    name: "coursePlay",
                                    params: {
                                      courseId: this.courseId,
                                      packagebagId: this.packagebagId,
                                      ccId: ccId,
                                      vid: vid,
                                      courseDelayTime: courseDelayTime,
                                      courseOver: courseOver,
                                      liSelected: index + "-" + sub,
                                      resouceHours: resouceHours,
                                      isPdf:true
                                    },
                                    query:{
                                      studyEntpId:that.studyEntpId
                                    }
                                  });
                                }else if(extension =='txt'){
                                  let strData = new Blob([coursewareUrl], { type: 'text/plain;charset=utf-8' });
                                  saveAs(strData,ccName);
                                  let data = {
                                    packagebagId: this.packagebagId, // 套餐包Id
                                    regId: this.regId,
                                    courseId: this.courseId, // 课程Id
                                    ccId: ccId, //视频VID
                                    courseDelayTime: 1, //视频播放时长
                                    courseOver: 1,
                                  };
                                  saveUserStudyTime(data).then(res => {
                                    if (res.code ==200) {
                                      this.getCourseBaseInfo()
                                    }
                                  })
                                }else{
                                  window.open(coursewareUrl)
                                  let data = {
                                    packagebagId: this.packagebagId, // 套餐包Id
                                    regId: this.regId,
                                    courseId: this.courseId, // 课程Id
                                    ccId: ccId, //视频VID
                                    courseDelayTime: 1, //视频播放时长
                                    courseOver: 1,
                                  };
                                  saveUserStudyTime(data).then(res => {
                                    if (res.code ==200) {
                                      this.getCourseBaseInfo()
                                    }
                                  })
                                }
                              }
                            })
                          } else {
                            const extension = coursewareUrl.substring(coursewareUrl.lastIndexOf('.') + 1).toLowerCase();
                            if(extension =='pdf'){
                              this.$router.replace({
                                name: "coursePlay",
                                params: {
                                  courseId: this.courseId,
                                  packagebagId: this.packagebagId,
                                  ccId: ccId,
                                  vid: vid,
                                  courseDelayTime: courseDelayTime,
                                  courseOver: courseOver,
                                  liSelected: index + "-" + sub,
                                  resouceHours: resouceHours,
                                  isPdf:true
                                },
                                query:{
                                  studyEntpId:that.studyEntpId
                                }
                              });
                            }else if(extension =='txt'){
                              let strData = new Blob([coursewareUrl], { type: 'text/plain;charset=utf-8' });
                              saveAs(strData,ccName);
                              let data = {
                                packagebagId: this.packagebagId, // 套餐包Id
                                regId: this.regId,
                                courseId: this.courseId, // 课程Id
                                ccId: ccId, //视频VID
                                courseDelayTime: 1, //视频播放时长
                                courseOver: 1,
                              };
                              saveUserStudyTime(data).then(res => {
                                if (res.code ==200) {
                                  this.getCourseBaseInfo()
                                }
                              })

                            }else{
                              window.open(coursewareUrl)
                              let data = {
                                packagebagId: this.packagebagId, // 套餐包Id
                                regId: this.regId,
                                courseId: this.courseId, // 课程Id
                                ccId: ccId, //视频VID
                                courseDelayTime: 1, //视频播放时长
                                courseOver: 1,
                              };
                              saveUserStudyTime(data).then(res => {
                                if (res.code ==200) {
                                  this.getCourseBaseInfo()
                                }
                              })
                            }
                          }
                        }
                      } else {
                        if (response.data.needLimit == 0) {
                          let data = {}
                          data.courseId = this.courseId
                          getStudyccCountToday(data).then(ressssss => {
                            if (ressssss.data >= response.data.limitClassHour) {
                              if (courseOver == 1 || courseOver == 0) {
                                this.$router.replace({
                                  name: "coursePlay",
                                  params: {
                                    courseId: this.courseId,
                                    packagebagId: this.packagebagId,
                                    ccId: ccId,
                                    vid: vid,
                                    courseDelayTime: courseDelayTime,
                                    courseOver: courseOver,
                                    liSelected: index + "-" + sub,
                                    resouceHours: resouceHours,
                                    isPdf:true
                                  },
                                  query:{
                                    studyEntpId:that.studyEntpId
                                  }
                                });
                              } else {
                                this.$message({
                                  message: '当日可学习课时已学完，请明日在进行学习',
                                  type: 'warning',
                                  duration: '3000',
                                })
                              }
                            } else {
                              const extension = coursewareUrl.substring(coursewareUrl.lastIndexOf('.') + 1).toLowerCase();
                              if(extension =='pdf'){
                              this.$router.replace({
                                name: "coursePlay",
                                params: {
                                  courseId: this.courseId,
                                  packagebagId: this.packagebagId,
                                  ccId: ccId,
                                  vid: vid,
                                  courseDelayTime: courseDelayTime,
                                  courseOver: courseOver,
                                  liSelected: index + "-" + sub,
                                  resouceHours: resouceHours,
                                  isPdf:true
                                },
                                query:{
                                  studyEntpId:that.studyEntpId
                                }
                              });
                            }else if(extension =='txt'){
                              let strData = new Blob([coursewareUrl], { type: 'text/plain;charset=utf-8' });
                              saveAs(strData,ccName);
                              let data = {
                                packagebagId: this.packagebagId, // 套餐包Id
                                regId: this.regId,
                                courseId: this.courseId, // 课程Id
                                ccId: ccId, //视频VID
                                courseDelayTime: 1, //视频播放时长
                                courseOver: 1,
                              };
                              saveUserStudyTime(data).then(res => {
                                if (res.code ==200) {
                                  this.getCourseBaseInfo()
                                }
                              })

                            }else{
                              window.open(coursewareUrl)
                              let data = {
                                packagebagId: this.packagebagId, // 套餐包Id
                                regId: this.regId,
                                courseId: this.courseId, // 课程Id
                                ccId: ccId, //视频VID
                                courseDelayTime: 1, //视频播放时长
                                courseOver: 1,
                              };
                              saveUserStudyTime(data).then(res => {
                                if (res.code ==200) {
                                  this.getCourseBaseInfo()
                                }
                              })
                            }
                            }
                          })
                        } else {
                          const extension = coursewareUrl.substring(coursewareUrl.lastIndexOf('.') + 1).toLowerCase();
                          if(extension =='pdf'){
                            this.$router.replace({
                              name: "coursePlay",
                              params: {
                                courseId: this.courseId,
                                packagebagId: this.packagebagId,
                                ccId: ccId,
                                vid: vid,
                                courseDelayTime: courseDelayTime,
                                courseOver: courseOver,
                                liSelected: index + "-" + sub,
                                resouceHours: resouceHours,
                                practicePlayFlag : practicePlayFlag,
                                exerciseId : exerciseId,
                                ccName : ccName,
                                isPdf:true
                              },
                              query:{
                                studyEntpId:that.studyEntpId
                              }
                            });
                          }else if(extension =='txt'){
                            let strData = new Blob([coursewareUrl], { type: 'text/plain;charset=utf-8' });
                            saveAs(strData,ccName);
                            let data = {
                              packagebagId: this.packagebagId, // 套餐包Id
                              regId: this.regId,
                              courseId: this.courseId, // 课程Id
                              ccId: ccId, //视频VID
                              courseDelayTime: 1, //视频播放时长
                              courseOver: 1,
                            };
                            saveUserStudyTime(data).then(res => {
                              if (res.code ==200) {
                                this.getCourseBaseInfo()
                              }
                            })
                            
                          }else{
                            window.open(coursewareUrl)
                            let data = {
                              packagebagId: this.packagebagId, // 套餐包Id
                              regId: this.regId,
                              courseId: this.courseId, // 课程Id
                              ccId: ccId, //视频VID
                              courseDelayTime: 1, //视频播放时长
                              courseOver: 1,
                            };
                            saveUserStudyTime(data).then(res => {
                              if (res.code ==200) {
                                this.getCourseBaseInfo()
                              }
                            })
                          }
                        }
                      }
                    })
                  }
                  localStorage.setItem("oldTokenId", localStorage.getItem("tokenId"));
                  const extension = coursewareUrl.substring(coursewareUrl.lastIndexOf('.') + 1).toLowerCase();
                  if(extension=='pdf'){
                    this.isPdf = true
                  }else{
                    this.isPdf =false;
                  }
                  let playData = {
                    courseId: this.courseId,
                    regId: this.regId,
                    packagebagId: this.packagebagId,
                    ccId,
                    vid,
                    courseDelayTime,
                    courseOver,
                    liSelected: index + "-" + sub,
                    resouceHours,
                    practicePlayFlag,
                    exerciseId,
                    ccName,
                    isPdf:this.isPdf,
                    coursewareUrl:this.isPdf==true?coursewareUrl:''
                  };
                  localStorage.setItem("playData", JSON.stringify(playData))
                } else {
                  this.$message({
                    message: '还没有上传视频哦！',
                    type: 'warning',
                    duration: '3000',
                  })
                }
              } else {
                this.$message({
                  message: '课程已经过了有效期，请联系' + this.entpName + '续费',
                  type: 'warning',
                  duration: '3000',
                })
              }
            }
          } else {
            this.$message.error(res.msg)
          }
        })
      }

    },


    //开始练习
    startExercise(exerciseId) {
      if (this.buyStatus == 0) {
        if (this.courseDistributionMode == 0) {
          if (this.salesmanCode) {
            this.popBuy = true;
          } else {
            this.$alert("该资源为付费内容，请先联系" + this.entpName + "购买，方可使用！", '提示', {
              confirmButtonText: '确定',
              callback: action => {}
            });
          }
        } else {
          this.popupDialog = true
        }
      } else {
        let data = {
          exerciseId: exerciseId,
          courseId: this.courseId,
          regId:this.regId
        };
        exerciseDetailVerification(data).then(res => {
          if (res.code == 200) {
            getEmployeeInformation().then(response => {
              let data2 = {
                exerciseId: exerciseId
              };
              getEntpExerciseConfigCurrent(data2).then(resdata => {
                //判断实名
                if (resdata.data.needRealName == 0) {
                  if (!response.data.empIdcardFront) {
                    this.$message({
                      message: '请先进行实名认证',
                      type: 'warning',
                      duration: '3000',
                    })
                  } else {
                    //判断是否课程学完才能练习
                    if (resdata.data.exerciseTimeLimit == 1) {
                      let data = {
                        courseId: this.courseId,
                        empId: response.data.empId
                      }
                      getEmployeeCourseOverStatus(data).then(res => {
                        if (res.data != 1) {
                          this.$message({
                            message: '请先学完课程在进行练习',
                            type: 'warning',
                            duration: '3000',
                          })
                        } else {
                          //判断练习次数限制
                          if (resdata.data.exerciseNumberLimit == 1) {
                            let data = {
                              exerciseId: exerciseId
                            }
                            getEmployeeExerciseCountByExerciseId(data).then(res => {
                              if (res.data >= resdata.data.maxExerciseNumber) {
                                this.$message({
                                  message: '当前练习次数已经用完',
                                  type: 'warning',
                                  duration: '3000',
                                })
                              } else {
                                this.$router.push({
                                  path: "/examDetail",
                                  query: {
                                    exerciseId: exerciseId,
                                    courseId: this.courseId,
                                    resultShow: response.data.resultShow,
                                    exerciseCate: 0
                                  }
                                });
                              }
                            })
                          }
                        }
                      })
                    } else {
                      //判断练习次数限制
                      if (resdata.data.exerciseNumberLimit == 1) {
                        let data = {
                          exerciseId: exerciseId
                        }
                        getEmployeeExerciseCountByExerciseId(data).then(res => {
                          if (res.data >= resdata.data.maxExerciseNumber) {
                            this.$message({
                              message: '当前练习次数已经用完',
                              type: 'warning',
                              duration: '3000',
                            })
                          } else {
                            this.$router.push({
                              path: "/examDetail",
                              query: {
                                exerciseId: exerciseId,
                                courseId: this.courseId,
                                resultShow: response.data.resultShow,
                                exerciseCate: 0
                              }
                            });
                          }
                        })
                      } else {
                        this.$router.push({
                          path: "/examDetail",
                          query: {
                            exerciseId: exerciseId,
                            courseId: this.courseId,
                            resultShow: response.data.resultShow,
                            exerciseCate: 0
                          }
                        });
                      }
                    }
                  }
                } else {
                  //判断是否课程学完才能练习
                  if (resdata.data.exerciseTimeLimit == 1) {
                    let data = {
                      courseId: this.courseId,
                      empId: response.data.empId
                    }
                    getEmployeeCourseOverStatus(data).then(res => {

                      if (res.data != 1) {
                        this.$message({
                          message: '请先学完课程在进行练习',
                          type: 'warning',
                          duration: '3000',
                        })
                      } else {
                        //判断练习次数限制
                        if (resdata.data.exerciseNumberLimit == 1) {
                          let data = {
                            exerciseId: exerciseId
                          }
                          getEmployeeExerciseCountByExerciseId(data).then(res => {
                            if (res.data >= resdata.data.maxExerciseNumber) {
                              this.$message({
                                message: '当前练习次数已经用完',
                                type: 'warning',
                                duration: '3000',
                              })
                            } else {
                              this.$router.push({
                                path: "/examDetail",
                                query: {
                                  exerciseId: exerciseId,
                                  courseId: this.courseId,
                                  resultShow: response.data.resultShow,
                                  exerciseCate: 0
                                }
                              });
                            }
                          })
                        } else {
                          this.$router.push({
                            path: "/examDetail",
                            query: {
                              exerciseId: exerciseId,
                              courseId: this.courseId,
                              resultShow: response.data.resultShow,
                              exerciseCate: 0
                            }
                          });
                        }
                      }
                    })
                  } else {
                    //判断练习次数限制

                    if (resdata.data.exerciseNumberLimit == 1) {
                      let data = {
                        exerciseId: exerciseId
                      }
                      getEmployeeExerciseCountByExerciseId(data).then(res => {
                        if (res.data >= resdata.data.maxExerciseNumber) {
                          this.$message({
                            message: '当前练习次数已经用完',
                            type: 'warning',
                            duration: '3000',
                          })
                        } else {
                          this.$router.push({
                            path: "/examDetail",
                            query: {
                              exerciseId: exerciseId,
                              courseId: this.courseId,
                              resultShow: response.data.resultShow,
                              exerciseCate: 0
                            }
                          });
                        }
                      })
                    } else {
                      this.$router.push({
                        path: "/examDetail",
                        query: {
                          exerciseId: exerciseId,
                          courseId: this.courseId,
                          resultShow: response.data.resultShow,
                          exerciseCate: 0
                        }
                      });
                    }
                  }
                }
              })
            })
          } else {
            if (this.salesmanCode) {
              this.popBuy = true;
            } else {
              this.$alert("该资源为付费内容，请先联系" + this.entpName + "购买，方可使用！", '提示', {
                confirmButtonText: '确定',
                callback: action => {}
              });
            }
          }
        })
      }
    },
    //百分比
    GetPercent(num, total) {
      num = parseFloat(num);
      total = parseFloat(total);
      if (isNaN(num) || isNaN(total)) {
        return "-";
      }
      return total <= 0 ? "0%" : (Math.round(num / total * 10000) / 100.00) + "%";
    },
    //环形图
    drawLine() {
      let myChart = echarts.init(document.getElementById('myChart'))
      myChart.setOption({
        tooltip: {
          trigger: 'item',
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        toolbox: {
          show: true,
          feature: {
            mark: {
              show: true
            },
            dataView: {
              show: true,
              readOnly: false
            },
            magicType: {
              show: true,
              type: ['pie', 'funnel'],
              option: {
                funnel: {
                  x: '25%',
                  width: '50%',
                  funnelAlign: 'center',
                  max: 1548
                }
              }
            },
            restore: {
              show: true
            },
            saveAsImage: {
              show: true
            }
          }
        },
        calculable: true,
        title: {
          text: '已完成',
          subtext: this.percentage,
          // sublink: 'http://e.weibo.com/1341556070/AhQXtjbqh',
          x: 'center',
          y: '30',
          itemGap: 5,
          textStyle: {
            color: '#666',
            fontSize: 12,
            fontWeight: 'normal'
          },
          subtextStyle: {
            color: '#3482ff',
            fontSize: 14,
            fontWeight: 600,
          }
        },
        series: [{
          name: '学习进度',
          type: 'pie',
          radius: ['68%', '90%'],
          center: ['50%', '50%'],
          hoverAnimation: false, //鼠标hover时不放大
          itemStyle: {
            normal: {
              color: function (params) {
                // build a color map as your need.
                var colorList = [
                  '#3482ff', '#ccc'
                ];
                return colorList[params.dataIndex]
              },
              label: {
                show: false
              },
              labelLine: {
                show: false
              }
            },
            emphasis: {
              label: {
                show: true,
                position: 'center',
                textStyle: {
                  fontSize: '30',
                  fontWeight: 'bold'
                },


              }
            }
          },
          data: [{
              value: this.courseCateCount,
              name: '已完成'
            },
            {
              value: (this.courseCateTotal - this.courseCateCount),
              name: '未完成'
            },

          ]
        }]
      })
    },
    handleClick(tab, event) {
      // console.log(tab, event);
    },
    //返回上一页
    goBack() {
      // this.$router.go(-1)
      // this.$router.replace({
      //   path: "/publicCourse",
      // })
      let linkRouter = sessionStorage.getItem('returnRouteBack')
      if (linkRouter == 'home') {
        this.$router.push('/home')
      } else if (linkRouter == 'StudyCentre') {
        this.$router.push('/StudyCentre')
      } else if (linkRouter == 'publicCourse') {
        this.$router.push('/publicCourse')
      }
    },
    //跳转播放
    toPlayVideo() {
      if (this.courseEndLine > 0 || this.courseType == "私有课程") {
        let playData = {
          courseId: this.courseId,
          regId: this.regId,
          packagebagId: this.packagebagId,
          trialFlag: this.trialFlag,
          practicePlayFlag : this.practicePlayFlag,
          exerciseId: this.exerciseId,
          ccName: this.ccName
        };
        localStorage.setItem("playData", JSON.stringify(playData));
        if (this.courseType == "私有课程") {
          this.$router.replace({
            name: "coursePlayByPrivate",
            params: {
              courseId: this.courseId
            }
          });
        } else {
          this.$router.replace({
            //   path: "/coursePlay",
            name: "coursePlay",
            params: {
              courseId: this.courseId,
              packagebagId: this.packagebagId,
              regId: this.regId
            },
            query:{
              studyEntpId:that.studyEntpId
            }
          });
        }
        localStorage.setItem("oldTokenId", localStorage.getItem("tokenId"));
      } else {
        this.$message({
          message: '课程已经过了有效期，请联系' + this.entpName + '续费',
          type: 'warning',
          duration: '3000',
        })
      }
    },

    //去练习
    goExercise(part){
      this.practicePopupDialog = true;
      this.ccName = part.ccName
      this.goExerciseId = part.exerciseId;
      this.ccId = part.ccId
    },
    close(){
      this.$refs.examDialog =''
      this.practicePopupDialog = false;
    },
     //关闭习题弹窗
     handleTitleClose(){
      this.$confirm('是否确定关闭该弹窗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.close()
        }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });          
      });
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/courseDetailNew/courseDetail.js